/**
 * @fileoverview Os modelos da OpenAI e os níveis de raciocínio que dá para
 * escolher no bloco "Agente IA" do fluxo e no agente de IA (Gerenciar Agentes).
 */

// Modelo da OpenAI que dá para escolher: desde 29/10/2026, só o GPT-5 Mini (as
// faixas de mensagens de IA dos planos são calculadas pelo custo dele). Manter em
// sincronia com SELECTABLE_AI_MODELS (backend OpenAiUsage/pricing.ts). Nó gravado
// com outro modelo roda no GPT-5 Mini.
export const AI_AGENT_MODEL_GROUPS = ["GPT-5 — com raciocínio"];

export const AI_AGENT_MODELS = [
  { value: "gpt-5-mini", label: "GPT-5 Mini", group: "GPT-5 — com raciocínio", short: "equilíbrio entre custo e qualidade (padrão)", desc: "Equilíbrio entre custo e qualidade. O padrão recomendado para atendimento." },
];

// Níveis de raciocínio (reasoning_effort): só valem nos modelos GPT-5. Menos
// raciocínio = menos tokens de saída cobrados = mais barato.
export const AI_AGENT_REASONING_LEVELS = [
  { value: "minimal", label: "Mínimo", desc: "Máxima economia" },
  { value: "low", label: "Baixo", desc: "Econômico" },
  { value: "medium", label: "Médio", desc: "Equilibrado" },
  { value: "high", label: "Alto", desc: "Mais caro" },
];
